import axiosInstance from "../../../api/axiosInstanceForMasterAPI";
import { MICROSOFT_CLIENT_STATE } from '../../../config/constants'

const AuthService = {
  init: async () => {
   
    const response = await axiosInstance.post("/api/v1/app/applications/init",
        {
            "org_id":localStorage.getItem('org_id')
        }
    );
    return response.data;
  },
  getConfig: async () => {
    const response = await axiosInstance.get("/api/v1/dashboard/home");
    return response.data;
  },
  getToken: async () => {
    const response = await axiosInstance.post("/api/v1/tokens/generate",{
        "global_id":localStorage.getItem('global_id')
    });
    return response.data;
  },
  login: async (data) => {
    const response = await axiosInstance.post("/api/v1/auth/login",data);
    return response.data;
  },
  verifyOtp: async (data) => {
    const response = await axiosInstance.post("/api/v1/auth/verify",data);
    return response.data;
  },
  getMicrosoftUrl: async () => {
    const response = await axiosInstance.post(
      "/api/v1/auth/get-authorization-url?source=web",
      {
        client_state: MICROSOFT_CLIENT_STATE,
      }
    );
    return response.data;
  },
  microsoftAuthCallback: async (params) => {
    const response = await axiosInstance.get(
      "/api/v1/auth/azure-oauth-callback", 
      {params}
    );
    return response.data;
  },
};

export default AuthService;
